export const IMPORT_ONE_PROGRAM = 'IMPORT_ONE_PROGRAM';

export const importOneProgram = data => ({
  type: IMPORT_ONE_PROGRAM,
  payload: data,
});
